import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { R2Api } from "../../api/r2/service.ts";
import { makeR2Api } from "../../api/r2/live.ts";
import { R2BrowserIo } from "./service.ts";

const pickFile = Effect.acquireUseRelease(
  Effect.try({ try: () => document.createElement("input"), catch: () => resourceUnavailable() }),
  input => Effect.callback<File | null, import("@workerstation/shared/errors/resource").ResourceFailure>(resume => {
    input.type = "file";
    input.onchange = () => resume(Effect.try({ try: () => input.files?.[0] ?? null, catch: () => resourceUnavailable() }));
    input.oncancel = () => resume(Effect.succeed(null));
    input.click();
  }).pipe(Effect.catchCause(() => Effect.fail(resourceUnavailable()))),
  input => Effect.sync(() => { input.onchange = null; input.oncancel = null; input.remove(); })
);

export const R2BrowserIoLive = Layer.succeed(R2BrowserIo, {
  pickFile,
  promptKey: Effect.fn("Frontend.R2.promptKey")((filename: string) => Effect.try({ try: () => window.prompt("R2 object key", filename), catch: () => resourceUnavailable() })),
  confirm: Effect.fn("Frontend.R2.confirm")((key: string) => Effect.try({ try: () => window.confirm(`Delete ${key}?`), catch: () => resourceUnavailable() })),
  download: Effect.fn("Frontend.R2.download")((descriptor: import("../../api/r2/model.ts").R2Download) => Effect.acquireUseRelease(
    Effect.try({ try: () => { const anchor = document.createElement("a"); anchor.href = withWorkerstationBase(descriptor.url); anchor.download = descriptor.filename; return anchor; }, catch: () => resourceUnavailable() }),
    anchor => Effect.try({ try: () => { document.body.appendChild(anchor); anchor.click(); }, catch: () => resourceUnavailable() }),
    anchor => Effect.sync(() => anchor.remove())
  ))
});
const R2BrowserApiLive = Layer.effect(R2Api, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeR2Api(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const R2BrowserPortsLive = Layer.merge(R2BrowserApiLive, R2BrowserIoLive);
